<template>
  <!-- 某个产品 下的 某个应用 -->
  <div :class="['package-item float_left', !applicationPermission[itemData.permissionId] ? 'invalid' : '']"
       @click.stop="jumpTo(itemData)"
       :ref="'application' + itemData.id">
    <span class="icon":style="{backgroundImage: iconList[itemData.permissionId] && iconList[itemData.permissionId].src ? 'url('+ iconList[itemData.permissionId].src +')' : ''}">
    </span>
    <p class="name">
      <span>{{itemData.title}}</span>
    </p>
    <div :class="['desc-box', tipsPosition, show ? 'show' : '']"
         v-if="!applicationPermission[itemData.permissionId]"
         :ref="'applicationTips' + itemData.id">
      <div class="inner">
        <p class="package-name">
          <span>{{itemData.title}}</span>
          <span class="status-tips">暂未购买</span>
        </p>
        <div class="slid-line"></div>
        <div class="desc">{{itemData.remark}}</div>
      </div>
    </div>
  </div>
</template>
<style lang="less" type="text/less"></style>
<script>
import {mapState} from 'vuex'
import * as domEvent from '@zjy/zjy-ui/lib/utils/dom'
const iconList = {
  9: {
    src: require('assets/images/applications/009.png'),
    name: '工程材料价格库'
  },
  10: {
    src: require('assets/images/applications/010.png'),
    name: '询价材料价格库'
  },
  11: {
    src: require('assets/images/applications/011.png'),
    name: '企业指标库'
  },
  12: {
    src: require('assets/images/applications/012.png'),
    name: '企业指标分析'
  },
  13: {
    src: require('assets/images/applications/013.png'),
    name: '指标项目估算'
  },
  14: {
    src: require('assets/images/applications/014.png'),
    name: '个人收藏'
  },
  15: {
    src: require('@/assets/images/icon-jjyj.png'),
    name: '计价依据库'
  }
}
export default {
  name: 'PackageItem',
  props: {
    itemData: {
      type: Object,
      default: () => {}
    },
    focusApplication: {}
  },
  computed: {
    ...mapState({
      applicationPermission: state => state.menus.applicationPermission
    })
  },
  data () {
    return {
      iconList,
      tipsPosition: '',
      show: false, // 显示产品说明
      clickEvent: null
    }
  },
  inject: ['rootPlatform'],
  beforeDestroy () {
    this.initEvent()
  },
  mounted () {
    this.initEvent(true)
    this.$nextTick(() => {
      this.judgePosition()
    })
    this.resizeHandle.resize(() => {
      this.judgePosition()
    })
  },
  methods: {
    initEvent (init) {
      if (this.clickEvent) {
        domEvent.off(document, 'click', this.clickEvent)
        this.clickEvent = null
      }
      if (init) {
        domEvent.on(document, 'click', this.clickEvent = () => {
          this.show = false
        })
      }
    },
    // 2. 查看某个云产品
    jumpTo (item) {
      if (!this.applicationPermission[item.permissionId]) {
        this.show = true
      }
      this.rootPlatform.focusApplication = item.id
      this.$emit('jumpToHandle', item, this.applicationPermission[item.permissionId] || false)
    },
    // 3. 判断 云产品介绍显示的位置
    judgePosition () {
      const applicationBox = this.$refs['application' + this.itemData.id]
      const applicationTipsBox = this.$refs['applicationTips' + this.itemData.id]
      if (applicationBox) {
        const position = applicationBox.getBoundingClientRect()
        if (position) {
          const windowWidth = document.documentElement.clientWidth
          const windowHeight = document.documentElement.clientHeight
          let tipsPosition = ''
          if (windowWidth - position.right < 280) {
            tipsPosition = 'left'
          }
          if (applicationTipsBox) {
            const height = applicationTipsBox.clientHeight
            if (windowHeight - position.top < height) {
              tipsPosition += 'bottom'
            }
          }
          this.tipsPosition = tipsPosition
        }
      }
    }
  },
  watch: {
    focusApplication () {
      if (+this.focusApplication !== +this.itemData.id) {
        this.show = false
      }
    }
  }
}
</script>
